function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner')?.classList.remove('hidden');

        const config = fetchConfig('json');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.headers['Content-Type'] = 'application/json';

        const purchaseOption = document.querySelector('[name="purchase_option"]:checked')
        const formData = new FormData(this.form);

            if(purchaseOption?.value == 'onetime' && window.onetime.id != null){  
              formData.delete('id');    
              formData.set('id',window.onetime.id);
            }


          const products = [];
          const addonInputs = document.querySelectorAll('[add-to-cart-check]');
          const infodiv = document.querySelector('product-info');
          const bundleType = infodiv?.getAttribute('data-bundle-type');


          let type;

          if (bundleType === 'Applicator') {
            type = 'Applicator';
          } else if (bundleType === 'single') {
            type = 'Single';
          } else {
            type = 'Scents';
          }

          const id = Date.now();

          products.push({
            id: formData.get('id'),
            quantity: Number(formData.get('quantity') || 1),
            properties: {
              '_Bundle': `${type} Bundle ${id}`
            }
          });
         

          if (addonInputs.length > 0) {
            addonInputs.forEach((input) => {
              const selling_plan = input.getAttribute('data-selling_plans');
              const findInputValue = input.closest('.add_btn_wrp_l');
              const qty_plus = findInputValue?.querySelector('.bundle-qty-input_l');
              const qty_plusvalue = qty_plus ? Number(qty_plus.value) : 1;

              const selectedPlan = document.querySelector('.all-plans .plan-card input:checked')?.value;

              if (input.value) {
                const product = {
                  id: input.value,
                  quantity: qty_plusvalue,
                  properties: {
                    '_Bundle': `${type} Bundle ${id}`
                  }
                };

                if (selectedPlan === 'subscription' && selling_plan) {
                  product.selling_plan = selling_plan;
                }

                products.push(product);
              }
            });
          }

            const ADDTOCART_OBJECT = {
              items: products,
              sections: this.cart 
                ? this.cart.getSectionsToRender().map((section) => section.id)
                : [],
              sections_url: window.location.pathname
            };

          console.log(ADDTOCART_OBJECT,"ADDTOCART_OBJECT")
          
            config.body = JSON.stringify(ADDTOCART_OBJECT);


            if (this.cart) {
              formData.append(
                'sections',
                this.cart.getSectionsToRender().map((section) => section.id)
              );
              formData.append('sections_url', window.location.pathname);
            }
        // config.body = formData;
        config.body = JSON.stringify(ADDTOCART_OBJECT);
      

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              sessionStorage.setItem('checkoutStarted', 'true');
              window.location = '/checkout';
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner')?.classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
